export default __webpack_public_path__ + "assets/moon-first-quarter.0028165c.svg";